import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { ProfessionContainer } from '../../Commons/Profession'
import { GenderContainer } from '../../Commons/Gender'

class More extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
    }

    render()
    {
        const { t } = this.props

        return (
            <div>
                <div>
                    {t("visualizer:toolbar.left.collaborativeIndexationCreation.form.population_census.steps.more.title")}
                </div>
                <ProfessionContainer hasFocus={true} />
                <GenderContainer />
            </div>
        )
    }
}

export default withTranslation()(More)
